var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentArrowOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4668 26H24.6387L22.0527 28.5859L23.4668 30L28.4668 25L23.4668 20L22.0527 21.4141L24.6387 24H16.4668V26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4668 21H8.4668V23H13.4668V21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4668 16H8.4668V18H18.4668V16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1668 9.3L16.1668 2.3C15.9668 2.1 15.7668 2 15.4668 2H5.4668C4.3668 2 3.4668 2.8999 3.4668 4V28C3.4668 29.103 4.3643 30 5.4668 30H13.4668V28H5.4668V4H13.4668V10C13.4668 11.1001 14.3668 12 15.4668 12H21.4668V18H23.4668V10C23.4668 9.7 23.3668 9.5 23.1668 9.3ZM15.4668 10V4.3999L21.0668 10H15.4668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentArrowOut);
export default __webpack_public_path__ + "static/media/ic-document-arrow-out.c6946d059b8ceda2828227882e91f004.svg";
export { ForwardRef as ReactComponent };